/* eslint-disable react-hooks/exhaustive-deps */
import  { useCallback, useEffect, useState } from 'react'
import { DataGrid, NGODatePicker } from '../../../common'
import { APIEndpoint } from '../../../utils/axios';
import { PageSizes } from '../../../utils/configs';
import viewIcon from "../../../assets/view.svg";
import { debounce, objectToQueryString } from '../../../utils/commonFunctions';
import closeIcon from '../../../images/icons/Icon2.png'

const Columns = [
  {field: 'firstName', headerName: 'First Name'},
  {field: 'secondName', headerName: 'Last Name'},
  {field: 'loyaltyPoints', headerName: 'Loyalty Points'},
  {field: 'nationality', headerName: 'Nationality'},
  {field: 'mobile', headerName: 'Mobile No'},
  {field: 'email', headerName: 'Email'},
]

const actionColumnProperties = {
  pinned: "right",
  minWidth: 80,
  width: 300,
  autoHeight: true,
  tooltipField: "View Items",
};

const filterData = {
    sector:{},
    limit: 50,
    page: 1,
    searchParam: "",
  }


export const PassengerDetails = () => {
  const [pageLimit, setPageLimit] = useState(50);
  const [searchKey] = useState('');
  const [actionItems] = useState([{
    title: "Actions",
    attribute: "viewItems",
  }])
  const [state, setState] = useState({});
  const [, setEditFormFields] = useState([]);
  const [sectorList, setSectorsList] = useState([]);
  const [ isReloadTableData, setIsReloadTableData ] = useState(false);
  const [sectorPageObj, setSectorPageObj] = useState({
    page: 1,
    size: 50,
    q: "",
  });
  const [sectorFilters, setSectorFilters] = useState({
    flightNumber: "",
    origin: "",
    destination: "",
    flightDate: new Date()
  });
  const [showGrid, setShowGrid] = useState(false)

  useEffect(()=>{
    getSectorList();
  },[])

  useEffect(()=>{
    fetchAllPassengers();
    setIsReloadTableData(!isReloadTableData)
  },[sectorFilters])

  const onAction = (e, action, row) => {
    onActionInner(e, action, row);
  };

  const onActionInner = (e, action, row) => {
    if (action.value === "viewItems") {
      let updatedEditFields = [];
      // setModalTitle("Passenger Inflight Details");

      updatedEditFields = [
        {
          label: "View Passenger Details",
          type: "viewPassengerDetails",
          attribute: "items",
        },
      ];

      updatedEditFields = updatedEditFields.filter((row) => {
        if (row.type === "viewPassengerDetails") {
          row.value = row;
        }
        return row;
      });

      setEditFormFields([...updatedEditFields]);
    }
    setState((_prev) => {
      return { ..._prev, selected: { ...row, action: action.value } };
    });
  };

  const getActionCellIcons = (cellDef, data) => {
    if (cellDef.attribute === "viewItems") {

      return [{ src: viewIcon, value: "viewItems", title: "View Passenger" }];
    }

    return [];
  };

  const onClose = () => {
    setState((_prev) => {
      return { ..._prev, selected: false };
    });
  };

  const fetchAllPassengers = async (page=1, perPage=50) => {
    filterData.page = page;
    filterData.limit = perPage;

    filterData.sector = {}

    if(sectorFilters.flightNumber){
      filterData.sector.flightNumber = sectorFilters.flightNumber
    }
    if(sectorFilters.origin){
      filterData.sector.origin = sectorFilters.origin
    }
    if(sectorFilters.destination){
      filterData.sector.destination = sectorFilters.destination
    }
    if(sectorFilters.flightDate){
      filterData.sector.flightDate = sectorFilters.flightDate
    }
    const res = await APIEndpoint.post('passenger/loyalty',JSON.stringify(filterData));
    if(res.items.length > 0){
      setShowGrid(true)
    }
    return res;
  };

  const onPerLimitChange = (e) => {
    setPageLimit(Number(e.target.value));
  };

  const getSectorList = useCallback(async () => {
    try {
      const resp = await APIEndpoint.get("stores/byPage?" + objectToQueryString(sectorPageObj));

      setSectorPageObj({ ...sectorPageObj, page: sectorPageObj.page + 1 });

      const list = [];
      if (resp.result.length > 0) {
        resp.result.forEach((_) => {
          list.push({ value: _.origin + "," + _.destination, id: _.id, label: _.value });
        });
        setSectorsList(list);
      }
    } catch (error) {
      console.error("Error fetching sector list:", error);

    }

    return false;
  }, [sectorPageObj]);


  const onSectorChange = (e) => {
    if(e.target.value){
      const [org,dest] = e.target.value.split(",");
      setSectorFilters(_=>{
        return {..._,origin:org,destination:dest}
      })
    }else{
      setSectorFilters(_=>{
        return {..._,origin:"",destination:""}
      })
    }
  };

  function handleFlightDateChange(e){
    const {value} = e.target;
    if(!value) return;
    setSectorFilters(_ => {
      return {..._,flightDate:value}
    })
  }

  const changeFlightNameHandler = debounce((e)=>handleFlightNameChange(e.target.value), 400)

  const handleFlightNameChange = (val)=>{
    setSectorFilters(prev=>{
      return {...prev,flightNumber:val}
    })
  }

  if(state && Boolean(state.selected) && state.selected?.action === "viewItems"){
    return (
      <div className="flexCol full-flex ag-theme-alpine-dark">
        <div className='justifyContentSpaceBetween flex alignItemsCenter'>
          <h4>Passenger Details</h4>
          <img className="modal__close_icon" alt='Close' src={closeIcon} onClick={onClose} style={{height:"auto"}} />
        </div>
        <div className="passengerDetailsBody" style={{marginTop:10}}>
          <table>
            <tr>
              <td width="30%">Name</td>
              <td>{`${state.selected.firstName} ${state.selected.secondName}`}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{state.selected.email}</td>
            </tr>
            <tr>
              <td>Nationality</td>
              <td>{state.selected.nationality ? state.selected.nationality : "--" }</td>
            </tr>
            <tr>
              <td>Mobile</td>
              <td>{state.selected.mobile ? state.selected.mobile : "--"}</td>
            </tr>
            <tr>
              <td>Country</td>
              <td>{state.selected.countryCode ? state.selected.countryCode : "--"}</td>
            </tr>
          </table>
        </div>
      </div>
    )
  }



  return (
    <>
     <div className="flexCol full-flex ag-theme-alpine-dark">

       <div className="flexRow width100 justifyContentFlexStart alignItemsCenter">
       <div className="flexRow">
         {/* filters and others */}
          <button className='page-button' style={{marginBottom:0}}>
            <select className="darkBlue-bg" onChange={onPerLimitChange} value={pageLimit} id="page-size">
              {
                PageSizes.map((_) => {
                  return (
                  <option key={_.value} value={_.value}>{_.label}</option>
                  )
              })
              }
            </select>
          </button>
       </div>
            <button className="sector-div m-2 margLeft">
              <select
                className="select-item darkBlue-bg"
                onChange={onSectorChange}
                value={sectorFilters.origin+","+sectorFilters.destination}
                id="sectorId"
              >
                <option key="" value="">
                  Select Sector
                </option>
                {sectorList.map((_) => {
                  return (
                    <option key={_.value} value={_.value}>
                      {_.label}
                    </option>
                  );
                })}
              </select>
            </button>

            <div>
            <NGODatePicker
                className="orderByDateInp"
                value={sectorFilters.flightDate}
                name="filterOrderDate"
                placeholder={"DD-MM-YYYY"}
                onChange={handleFlightDateChange}
                dateformat="dd-mm-yyyy"
              />
            </div>
            <div style={{marginLeft:15}}>
              <input className='edit-input' onChange={changeFlightNameHandler} type="number" placeholder='Flight number' defaultValue={sectorFilters.flightNumber} />
            </div>
       </div>
       {showGrid && (
        <>
        {/* Table Section */}
         <DataGrid
            className="full-flex"
            columns={Columns}
            initialPageLimit={pageLimit}
            showDefaultFilters={false}
            searchKey={searchKey}
            actionProperties={actionColumnProperties}
            getRows={fetchAllPassengers}
            noResultsMessage={"No Data"}
            rowSelection="multiple"
            columnResize={true}
            actions={actionItems}
            getActionCellIcons={getActionCellIcons}
            onAction={(e, action, data) => {
              return onAction(e, action, data);
            }}
            resetDataSource={isReloadTableData}
          />
        </>
       )}
    </div>

    </>
  )
}
